// extracted by mini-css-extract-plugin
export default {"inputTitle":"AddNewEnterprise_inputTitle__5GbSc","placeHolderShimmer":"AddNewEnterprise_placeHolderShimmer__mJ6lB"};